import React from 'react'
import MaterialSymbol from '../material-symbol'

const LeftPanelClose = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="left_panel_close" {...props} />
))

LeftPanelClose.displayName = 'LeftPanelClose'

export default LeftPanelClose
